import type { ProductAttributesFiltersType } from '@components/catalog/productAttribute/grid/ProductAttributesFilter'

import { makeFilter } from './crud/filters'


export const prepareProductAttributesFilter = (filters: ProductAttributesFiltersType) => {
  const idsFilter = makeFilter('id', 'contains', filters.ids)
  const nameFilter = makeFilter('name', 'starts_with', filters.name)
  const labelFilter = makeFilter('label', 'starts_with', filters.label)
  const typeFilter = makeFilter('type', 'eq', filters.type)

  return {
    and: [
      idsFilter,
      nameFilter,
      labelFilter,
      typeFilter
    ]
  }
}